import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignService } from '../campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from '../services/local-storage.service';

@Component({
  selector: 'app-campaign',
  standalone: true,
  imports: [],
  templateUrl: './campaign.component.html',
  styleUrl: './campaign.component.scss'
})
export class CampaignComponent {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private service: CampaignService,
    private translate: TranslateService,
    private localStorage: LocalStorageService,
  ) {

  }

  ngOnInit() {
    const lang = this.activatedRoute.snapshot.params['lang'];
    const cId = this.activatedRoute.snapshot.params['cId'];
    const restaurantId = this.activatedRoute.snapshot.params['rId'];

    if (['en', 'el', 'hr'].indexOf(lang) > -1) {
      this.translate.use(lang);
      this.localStorage.setLanguage(lang);
    }

    this.fetchLink(cId, restaurantId);
  }

  async fetchLink(cId: any, restaurantId: any) {
    this.service.getCampaignLink(cId, restaurantId).subscribe((data) => {
      this.router.navigate([`/pay/${data.id}`]);
    });
  }
}
